<script lang="ts" setup>
const props = defineProps<{ data: Business }>()
const businessRoute = getPublicRoute('businesses', { id: props.data.id, slug: props.data.slug, name: props.data.name })
const openContactModal = ref(false)
</script>

<template>
  <div
    class="flex flex-wrap gap-4 items-center rounded-xl p-2 md:p-3 lg:p-4 group duration-150 bg-blue text-white shadow">

    <div class="flex flex-wrap px-3 py-6 gap-3">
      <ImageFull :id="data.id" :src="data.logo" :collection-id="data.collectionId"
        class="rounded-full shadow w-full max-w-32" loading="lazy" />
      <div class="flex flex-col flex-1 text-sm justify-center text-yellow min-w-[60%]">
        <slot />
        <p class="text-lg xl:text-xl font-semibold !leading-none text-white">
          {{ data.name }}
        </p>
        <p>{{ data.brief }}</p>
      </div>
      <div class="my-3 gap-2 flex flex-wrap justify-end items-center">
        <UButton size="lg" trailing color="yellow" class="z-20" @click="openContactModal = true">
          Contact
          <Icon name="heroicons:cursor-arrow-ripple-solid" class="w-6 h-6  text-lightblue animate-pulse" />
        </UButton>
        <CollectionBusinessContactModal v-model:open="openContactModal" :data="data" />
        <UButton size="lg" trailing color="lightblue" class="z-20" :to="businessRoute">
          View Business
          <Icon name="gbf:arrow-right" class="w-6 h-6 animate-pulse text-yellow" />
        </UButton>
      </div>
    </div>
  </div>
</template>
